import {Injectable} from '@angular/core';
import {HttpServiceBase} from '../core/services/HttpServiceBase';
import {Rarity} from '../core/entities/entities';
import {HttpService} from '../core/services/http.service';
import {ServiceName} from '../core/services/Service';
import {HoloService} from './holo.service';

@Injectable()
export class RarityService extends HttpServiceBase<Rarity> {
  getCleanInstance(): Rarity {
    return new Rarity();
  }

  public hasSingleGet(){
    return false;
  }

  public refreshOnRouteChange(){
    return false;
  }

  constructor(protected http: HttpService) {
    super(http);
  }

  getUrl() {
    return  'rarity';
  }


}

ServiceName.add('RarityService', RarityService);




// WEBPACK FOOTER //
// ./src/app/services/rarity.service.ts